import { render, staticRenderFns } from "./array.vue?vue&type=template&id=237c99b2&"
import script from "./array.vue?vue&type=script&lang=js&"
export * from "./array.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports